import axios from 'axios';
import { notify } from '../helper/helper.service';

const baseUrl = 'https://backend.lumafertility.com/api/v1/';

class Service {
  constructor(props) {
    this.refreshHeader(() => {});
  }

  refreshHeader = async () => {
    const token = await sessionStorage.getItem('token');

    let srh = {
      headers: {
        Authorization: token != null ? token : '',
        Accept: 'application/json',
      },
      timeout: 6000, // Timeout in milliseconds
    };
    let service = axios.create(srh);
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  };

  handleSuccess(response) {
    return response;
  }

  handleError = error => {
    let code = 400;
    let message = '';
    if (error?.response) {
      code = error?.response?.status;
      message = error?.response?.data?.message
    } else if (error.request) {
      message = 'Network Error. Please check your connection.';
    } else if (error.code === 'ECONNABORTED') {
      message = 'Request timed out. Please try again later.';
    } else {
      message = error.message || 'An error occurred.';
    }

    switch (code) {
      case 401:
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('tasklist');
        break;
      case 404:
        break;
      default:
        if (message) {
          console.log(message); 
        }
        break;
    }

    // notify(error, 'error')
    console.log('Network Error Details', error);
    return Promise.reject(error);
  };

  logout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('tasklist');
  };

  validateToken = response => {
    if (response.code == 401) {
      this.logout();
    }
  };

  redirectTo = (document, path) => {
    document.location = path;
  };

  get(path, callback, error) {
    var respp = this.service
      .get(`${baseUrl}/${path}`)
      .then(response => {
        return callback(response.status, response?.data);
      })
      .catch(err => {
        return error(err);
      });
    return respp;
  }

  patch(path, payload, callback) {
    return this.service
      .request({
        method: 'PATCH',
        url: `${baseUrl}${path}`,
        responseType: 'json',
        data: payload,
      })
      .then(response => callback(response.status, response.data));
  }

  post(path, payload, callback, error) {
    return this.service
      .request({
        method: 'POST',
        url: `${baseUrl}${path}`,
        responseType: 'json',
        data: payload,
      })
      .then(response => {
        return callback(response.status, response?.data);
      })
      .catch(err => {
        return error(err);
      });
  }

  put(path, payload, callback) {
    return this.service
      .request({
        method: 'PUT',
        url: `${baseUrl}${path}`,
        responseType: 'json',
        data: payload,
      })
      .then(response => callback(response.status, response.data));
  }
}

export default new Service();
